import { defineComponent as _defineComponent } from 'vue'
import {ReferenceRateType} from '@/models/simulation/ReferenceRateType';
import {computed} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferenceRateIcon',
  props: {
    referenceRate: null
  },
  setup(__props: any) {

const props = __props as {
  referenceRate: ReferenceRateType;
}




const icon = computed<string>(() => {
  switch (props.referenceRate) {
  case ReferenceRateType.WIBOR_3M:
    return 'mdi-numeric-3-box-outline';
  case ReferenceRateType.WIBOR_6M:
    return 'mdi-numeric-6-box-outline';
  case ReferenceRateType.WIRON_1M:
    return 'mdi-numeric-1-box';
  default:
    return '';
  }
});

return { __sfc: true,props, icon }
}

})